import { render, staticRenderFns } from "./salesTeam.vue?vue&type=template&id=461ca0b0&scoped=true"
import script from "./salesTeam.vue?vue&type=script&lang=js"
export * from "./salesTeam.vue?vue&type=script&lang=js"
import style0 from "./salesTeam.vue?vue&type=style&index=0&id=461ca0b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ca0b0",
  null
  
)

export default component.exports